// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1121":"build/admin","6275":"build/story","8357":"build/app","9811":"build/story-itinerary"}[chunkId] + ".css";
};